module.exports = "/images/ng.svg?ecfb434222f20cc43aea96ae87d4b562";